import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading, setResult, setError } from '../../store/imageDescriptionSlice';
import { emitWhenConnected } from '../socketHelpers';

export function useImageDescriptionApi(socket) {
  const dispatch = useDispatch();

  const getImageDescription = useCallback(
    (imageBase64, callback) => {
      if (!socket) {
        dispatch(setLoading(false));
        dispatch(setError('Сокет не подключен'));
        if (callback) callback('Сокет не подключен', null);
        return;
      }

      dispatch(setLoading(true));
      dispatch(setError(null));
      dispatch(setResult(null));

      emitWhenConnected(socket, () => {
        socket.emit('get_image_description', { image: imageBase64 }, (response) => {
          dispatch(setLoading(false));
          if (response?.status === 'ok' && response?.description != null) {
            dispatch(setResult(response.description));
          } else {
            dispatch(setError(response?.message || 'Не удалось получить описание'));
          }
          if (callback) callback(response);
        });
      });
    },
    [socket, dispatch]
  );

  return { getImageDescription };
}
